<div class="week-picker" [ngClass]="{ 'is-disabled': disabled }">
  <div
    class="input"
    [ngClass]="{ 'is-active': popup, 'is-danger': isInvalid }"
    (click)="toggle($event)"
    (keydown.ArrowUp)="toggle($event)"
    (keydown.ArrowDown)="toggle($event)"
    (keyup.enter)="toggle($event)"
    tabindex="0"
  >
    Week&nbsp;{{ week ? week : "--" }}
    @if (showYears) {
      <span>,&nbsp;{{ year ? year : "--" }}</span>
    }
  </div>
</div>
